export default __webpack_public_path__ + "static/1231-97f4df68db870617eadd08f4236eab8c.gif";